module.exports = __webpack_public_path__ + "assets/img/5.78d591f6.png";